import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    imei: {
        defaultMessage: 'IMEI',
        id: 'iaso.devices.imei',
    },
    test_device: {
        defaultMessage: 'Test Device',
        id: 'iaso.devices.test_device',
    },
    last_owner: {
        defaultMessage: 'Last owner',
        id: 'iaso.devices.last_owner',
    },
    timeSynched: {
        defaultMessage: 'Time Synched',
        id: 'iaso.devices.timeSynched',
    },
    timeCreated: {
        defaultMessage: 'Time Created',
        id: 'iaso.devices.timeCreated',
    },
    timeUpdated: {
        defaultMessage: 'Time Updated',
        id: 'iaso.devices.timeUpdated',
    },
    devices: {
        defaultMessage: 'Devices',
        id: 'iaso.label.devices',
    },
    yes: {
        defaultMessage: 'Yes',
        id: 'iaso.label.yes',
    },
    no: {
        defaultMessage: 'No',
        id: 'iaso.label.no',
    },
});

export default MESSAGES;
